export default __webpack_public_path__ + "static/media/school-medium.6381cd93.png";